import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { SearchIcon } from '../mui/Icons'
import { Box, InputBase } from '../mui/Core'
import { useTheme } from '../mui/Styles/index'

const Search = styled(Box)(({ theme }) => ({
  height: 36,
  minWidth: '300px',
  position: 'relative',
  backgroundColor: 'none',
  marginRight: theme.spacing(0),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: { marginLeft: theme.spacing(0), width: 'auto' },
}))

const SearchIconWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({ theme, texttransform }) => ({
  height: 35,
  paddingBottom: '4px',
  backgroundColor: 'transparent',
  color: theme.palette.disabled,
  fontSize: '16px',
  '& .MuiInputBase-input': {
    padding: theme.spacing(2, 1, 0, 0),
    /* vertical padding + font size from searchIcon */
    paddingLeft: `calc(22px + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    textTransform: `${texttransform}`,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}))

function GenericSearch({ returnSearch }) {
  const theme = useTheme()
  const [searchVal, setSearchVal] = useState('')

  const handleInputOnChange = (event) => {
    setSearchVal(event.target.value)
    returnSearch(event.target.value)
  }

  const styledBorder = {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.grey[700],
    border: 1,
    borderRadius: theme.shape.borderRadius,
    height: '36px',
    alignItems: 'center',
    display: 'flex',
    ':focus-within': {
      border: '2px solid',
      borderColor: `${theme.palette.secondary.main} !important`,
    },
  }

  const searchIconStyle = { fontSize: '28px' }

  return (
    <Box display='flex' sx={styledBorder}>
      <Search>
        <SearchIconWrapper>
          <SearchIcon sx={searchIconStyle} />
        </SearchIconWrapper>
        <StyledInputBase
          value={searchVal}
          placeholder='Search…'
          inputProps={{ 'aria-label': 'search' }}
          onChange={handleInputOnChange}
          onKeyDown={handleInputOnChange}
          texttransform='none'
        />
      </Search>
    </Box>
  )
}

GenericSearch.propTypes = {
  returnSearch: PropTypes.func.isRequired,
}

export default GenericSearch
